import { Command } from 'commander'
import { createClient } from '../../client.js'
import { resolveWorkspace } from '../../lib/workspace-resolver.js'
import { handleError } from '../../lib/errors.js'
import {
  isQuiet,
  printQuiet,
  printJson,
  printKeyValue,
  printSuccess,
} from '../../output.js'

export const projectsCreateCommand = new Command(`create`)
  .usage(`--name <name> [options]`)
  .description(`Create a new project`)
  .requiredOption(`--name <name>`, `Project name`)
  .option(`--workspace <id>`, `Workspace ID`)
  .option(`--default-environment <name>`, `Default environment name`, `Main`)
  .action(async (opts) => {
    const json = projectsCreateCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const workspaceId = await resolveWorkspace(client, opts.workspace)
      const result = await client.projects.create({
        workspaceId,
        name: opts.name,
        defaultEnvName: opts.defaultEnvironment,
      })

      if (isQuiet()) {
        printQuiet(result.projectId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Project created successfully.\n`)
        printKeyValue([
          [`Project ID:`, result.projectId],
          [`Environment ID:`, result.environmentId],
        ])
      }
    } catch (error) {
      handleError(error, json)
    }
  })
